import { css, CSSResult } from 'lit'
import { csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseText = {
  textAlign: css`var(--cse-text-text-align, start)`,
  color: css`var(--cse-text-color, inherit)`,
  gap: css`var(--cse-text-gap, ${csSpacing.spacing05})`,
  prefixAlignSelf: css`var(--cse-text-prefix-align-self, center)`,
  overflow: css`var(--cse-text-overflow, visible)`,
  whiteSpace: css`var(--cse-text-white-space, normal)`,
  textOverflow: css`var(--cse-text-text-overflow, clip)`
}

export const style: CSSResult = css`
  .cse-text {
    margin: 0;
    text-align: ${cseText.textAlign};
    transition-duration: ${csTransition.duration};
    transition-timing-function: ${csTransition.timingFunction};
    transition-property: color;
    overflow: ${cseText.overflow};
    white-space: ${cseText.whiteSpace};
    text-overflow: ${cseText.textOverflow};
  }

  .cse-text.has-icon {
    display: flex;
    gap: ${cseText.gap};
    align-items: center;
  }

  .cse-text.has-icon ::slotted([slot="prefix"]) {
    align-self: ${cseText.prefixAlignSelf};
  }

  .cse-text.clamped:not(.has-icon) {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: var(--cse-text-line-clamp);
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .cse-text.clamped .content {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: var(--cse-text-line-clamp);
  }
`
